<template>
  <el-row class='helpList' style="width:100%">
       <el-col :span="24">
            <div class="help-search-wp">
                <div class="clear-fix wh1200">
                    <div class="help-wp2-search">
                        <el-input placeholder="试试搜索关键词" v-model="searchForm">
                            <el-button @click="search" slot="append"><i class="fa fa-search"></i></el-button>
                        </el-input>
                    </div>
                </div>
            </div>
        </el-col>   
        <el-col :span="24">
            <div class="wh1200 help-wp6">
                <el-col :class="{'isFixed':!isOnTop}"  :span="5" id='fixedBar'>
                    <div class="clear-fix help-wp5 help-left1" >
                        <div class="help-left-wp">
                            <h2 class="help-left-title">帮助中心</h2>
                            <el-collapse accordion>
                                <el-collapse-item>
                                    <template slot="title">委托管理</template>
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('1_1')" href="javascript:;">委托业务简介</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('1_2')" href="javascript:;">委托订单列表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('1_3')" href="javascript:;">租赁收入列表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('1_4')" href="javascript:;">出售收入列表</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="租赁管理">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('2_1')" href="javascript:;">租赁业务简介</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('2_2')" href="javascript:;">租赁订单查询</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('2_3')" href="javascript:;">租赁价格查询</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="库存查询">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('3_1')" href="javascript:;">委托库查询</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('3_2')" href="javascript:;">代管库查询</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="维修查询">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('4_1')" href="javascript:;">维修业务简介</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('4_2')" href="javascript:;">维修下单列表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('4_3')" href="javascript:;">维修价格查询</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="物流信息查询">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('5_1')" href="javascript:;">发货单列表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('5_2')" href="javascript:;">物流信息列表</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="财务查询">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_1')" href="javascript:;">委托收益报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_2')" href="javascript:;">委托销售报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_3')" href="javascript:;">维修支出报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_4')" href="javascript:;">物流支出报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_5')" href="javascript:;">租赁支出报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_6')" href="javascript:;">保证金报表</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('6_7')" href="javascript:;">代管库支出报表</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="订单管理">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('7_1')" href="javascript:;">发货通知单</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('7_2')" href="javascript:;">采购询价单</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('7_3')" href="javascript:;">委托申请单</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('7_4')" href="javascript:;">调度申请单</a></li>
                                    </ul>
                                </el-collapse-item>
                                <el-collapse-item title="个人中心">
                                    <ul class="help-left-ul1">
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('8_1')" href="javascript:;">公司信息</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('8_2')" href="javascript:;">服务网点维护</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('8_3')" href="javascript:;">工程师信息维护</a></li>
                                        <li><i class="fa fa-angle-right"></i><a @click="showHelp('8_4')" href="javascript:;">在线反馈</a></li>
                                    </ul>
                                </el-collapse-item>
                            </el-collapse>
                        </div>
                    </div>
                </el-col>
                <el-col :span="19" :class="{'FixedRightBox':!isOnTop}">
                    <div v-if="resultForm.length==0" class="clear-fix help-wp5-bg help-right1">
                        <h3 class="help-right1-title2">抱歉，没有找到“<span>{{SearchWords}}</span>”的内容</h3>
                        <div class="help-no-text">
                            <p>我们建议您：</p>
                            <p>· 查看输入的文字是否正确；</p>
                            <p>· 还未解决，可以尝试下面的方式与我们联系。</p>
                        </div>
                    </div>
                    <div v-else class="clear-fix help-wp5 help-right1">
                        <div v-if="SearchWords">
                            <h3 class="help-right1-title2">关于“<span>{{SearchWords}}</span>”的搜索结果  共 <strong>{{resultForm.length}}</strong> 条</h3>
                            </div>
                            <!-- 委托业务简介 -->
                            <div v-if="resultForm.includes('1_1')">
                            <h4 id="o-help1" class="pt-10">一、委托业务简介</h4>
                            <p>(1)、合作库是对接行业（国内、外客户）的配件需求的平台，能快速帮助用户实际价值转化，委托业务介绍如下：</p>
                            <table class="table-01">
                                <colgroup>
                                    <col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>委托业务</th>
                                    <th>委托销售</th>
                                    <th>委托租赁</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>结算方式</td>
                                    <td>售出即结算（数据同步）</td>
                                    <td>租期结束即结算（数据同步）</td>
                                </tr>
                                <tr>
                                    <td>结算金额</td>
                                    <td>委托价格=结算金额</td>
                                    <td>租赁价格分成</td>
                                </tr>
                                <tr>
                                    <td>费用（委托代管）</td>
                                    <td colspan="2">免费</td>
                                </tr>
                                <tr>
                                    <td>品质（委托加入）</td>
                                    <td>≥七成新</td>
                                    <td>①原装全新   ②八成新</td>
                                </tr>
                                <tr>
                                    <td>品质（退还）</td>
                                    <td>按验收入库的同等品质</td>
                                    <td>①九五成新装   ②≥七成新</td>
                                </tr>
                                <tr>
                                    <td>锁定期</td>
                                    <td>≥3个月</td>
                                    <td>≥3个月（以租赁合同为准）</td>
                                </tr>
                                <tr>
                                    <td>物流费用（委托加入与退还）</td>
                                    <td colspan="2">发货方承担</td>
                                </tr>
                                <tr>
                                    <td>库管特点</td>
                                    <td colspan="2">共享库</td>
                                </tr>
                                <tr>
                                    <td>服务特点</td>
                                    <td colspan="2">合作库提供免费委托产品仓储、专业管理与运营服务</td>
                                </tr>
                                </tbody>
                            </table>
                            <p>(2)、委托业务流程</p>
                            <p>1>了解委托业务--》联系客服或业务员--》提交委托清单---》委托报价确认---》发货---》二次确认--》上线销售（用户在了解进度）</p>
                            <div><img src="../../../assets/menu_img6.jpg" alt="委托业务流程"></div>
                        </div>
                        <!-- 委托订单列表 -->
                        <div v-if="resultForm.includes('1_2')">
                            <h4 id="o-help2" class="pt-10">二、委托订单列表</h4>
                            <p>已达成的产品委托业务在订单“委托订单列表展示查询。</p>
                            <p>1>.点击首页标题“委托查询”，选择“委托订单列表”进入委托订单管理；2>.输入：物料名称、委托订单、委托类型、区域等内容任义条件了解委托订单的情况（图1），或通过选择“委托方待发货、受托方处理中、已完成”了解委托物料的状态展示(图2)。</p>
                            <div class="pt-10"><img src="../../../assets/help-img1.jpg" alt="委托订单"></div>
                            <div class="pt-10"><img src="../../../assets/help-img2.jpg" alt="委托订单"></div>
                        </div>
                        <!-- 租赁收入列表 -->
                        <div v-if="resultForm.includes('1_3')">
                            <h4 id="o-help3" class="pt-10">三、租赁收入列表</h4>
                            <p>租赁收入列表是指委托产品通过平台租赁给第三方的收入所得，展示信息包含已结算、待结算的业务信息。</p>
                            <p>1>点击“委托查询”选择“租赁收入列表”能了解委托产品租赁的收入情况。</p>
                            <p>2>.过输入：物料名称、品牌、机型…… 区域等内容任义条件查询委托产品租赁收入情况；或通过选择“委托方待发货、受托方处理中、已完成”了解委托物料的状态展示。</p>
                            <div class="pt-10"><img src="../../../assets/help-img3.jpg" alt="委托订单"></div>
                            <p class="pt-10">3>.用户选择：租赁中、待收款、已收款等选项清楚了解委托产品的租赁结算状态，单一产品查询可点击“查看相关详情”了解详细的业务数据。</p>
                            <div class="pt-10"><img src="../../../assets/help-img4.jpg" alt="委托订单"></div>
                        </div>
                        <!-- 出售收入列表 -->
                        <div v-if="resultForm.includes('1_4')">
                            <h4 id="" class="pt-10">四、出售收入列表</h4>
                            <p>出售收入列表是指委托平台销售卖出的收入所得，这里展示的是销售订单已结算和待付款的业务信息。</p>
                            <p>1>点击“委托查询”选择“出售收入列表”查询所有委托产品的出售收入情况；</p>
                            <p>2>.快速单个产品结果查询方法：输入物料名称、品牌、机型…… 区域等条件筛选详细的收入；</p>
                            <p>3>.选择：待收款、已收款等选项清楚了解委托产品的结算状态，单一产品查询可点击“查看相关详情”了解详细的业务数据。</p>
                            <div class="pt-10"><img src="../../../assets/help-img5.jpg" alt="委托订单"></div>
                        </div>
                        <!-- 租赁业务简介  -->
                        <div v-if="resultForm.includes('2_1')">
                            <h4 class="pt-10">一、租赁业务简介</h4>
                            <p>(1)、租赁业务共享配件模式，相对传统采购配件能降低运营成本和人工成本，减少固定资产投入，配套购买维修、代管业务，一站式解决配件、维修、采购、物流等运营问题。</p>
                            <table width="100%" class="table-01">
                                <tbody>
                                <tr>
                                    <th rowspan="2" scope="row">租赁方式</th>
                                    <td colspan="2">固定租期</td>
                                    <td colspan="2">灵活租期</td>
                                </tr>
                                <tr>
                                    <td>产品裸租</td>
                                    <td>租赁保修价</td>
                                    <td>产品裸租</td>
                                    <td>租赁保修价</td>
                                </tr>
                                <tr>
                                    <th scope="row">租期</th>
                                    <td colspan="2">6个月，12个月，18个月随意选择</td>
                                    <td colspan="2">以3个月为基准随意选择</td>
                                </tr>
                                <tr>
                                    <th scope="row">是否保修</th>
                                    <td>否</td>
                                    <td>是（提供相应租期的保修）</td>
                                    <td>否</td>
                                    <td>是（提供相应租期的保修）</td>
                                </tr>
                                <tr>
                                    <th scope="row">是否能调整租期/产品</th>
                                    <td colspan="2">否</td>
                                    <td colspan="2">是</td>
                                </tr>
                                <tr>
                                    <th rowspan="2" scope="row">调整方式</th>
                                    <td colspan="2">提前15天</td>
                                    <td colspan="2">提前1个月</td>
                                </tr>
                                <tr>
                                    <td colspan="2">产品增加和延长：增加提交《租赁订单）</td>
                                    <td colspan="2">提出（租赁产品增加/减少、租期延长/缩短）调整需求</td>
                                </tr>
                                <tr>
                                    <th scope="row">保证金</th>
                                    <td colspan="4">租赁产品报价额的30%</td>
                                </tr>
                                <tr>
                                    <th scope="row">租金结算方式</th>
                                    <td colspan="4">按季度结算（租金含6%增值税服务性发票）</td>
                                </tr>
                                <tr>
                                    <th scope="row">租赁产品退还<br>
                                        （请参考合作库品项标准）</th>
                                    <td colspan="4">一、租赁产品为八成新的产品退回情况：<br>
                                        ● 原物退还（带完整条码和防伪标识）,无费用；<br>
                                        ● 非原物退还同等同质,配件完整,损耗类组件成色无要求的,无费用；<br>
                                        ● 非原物退还,品相低于7成新,配件完整,扣抵3个月租金；<br>
                                        ● 不完整配件退还,估值核算,按照6~12个月租赁费用扣抵）;<br>
                                        ● 产品损失,无产品退还；（按照18个月租赁费用扣抵）。<br>
                                        二、租赁产品为原装全新的产品退回情况：<br>
                                        ● 同等同质,配件完整,损耗类组件成色无要求,无费用；<br>
                                        ● 非同等同质,九五成新以上,配件完整可正常使用,损耗类组件成色无要求,无费用；<br>
                                        ● 非同等同质,低于九五成新,配件完整,损耗类组件成色无要求,（根据产品成色差异，按照3~12个月租赁费用扣抵）；<br>
                                        ● 不完整配件退还；估值核算,按照6~12个月租赁费用扣抵）;<br>
                                        ● 产品损失,无产品退还；（按照18个月租赁费用扣抵）。</td>
                                </tr>
                                <tr>
                                    <th scope="row">产品延期退还<br>
                                        收费标准</th>
                                    <td colspan="4">1.超过一周不到一月的按租赁协议的月费用收取。<br>
                                        2.超过一月不到两月或两个月整的按两个月收取。<br>
                                        3.超过三个月未退回的租赁配件,作配件遗失按照18个月租赁费用收取。</td>
                                </tr>
                                <tr>
                                    <th scope="row">保证金退还</th>
                                    <td colspan="4">合同结束后结清合同期的相应帐务后,7个工作日内退还</td>
                                </tr>
                                <tr>
                                    <th scope="row">合作库其它有偿服务任选</th>
                                    <td colspan="4">租赁产品委托仓储代管、物料配送、技术维修等一站式服务。</td>
                                </tr>
                                <tr>
                                    <th scope="row">增值服务</th>
                                    <td colspan="4">1.运营数据查询、调拨、管理；   2.大数据业务、行业、成本分析数据推送。</td>
                                </tr>
                                </tbody>
                            </table>
                            <p>(2)、租赁业务流程</p>
                            <div class="help-pd"><img src="../../../assets/menu_img7.png" alt="委托业务流程"></div>
                        </div>
                        <!-- 租赁订单查询 -->
                        <div v-if="resultForm.includes('2_2')">
                            <h4 class="pt-10">二、租赁订单查询</h4>
                            <p>(1)、租赁订单管理：所有发生租赁业务的订单在"租赁订单列表”均能展示查询，数据清晰便于管控。</p>
                            <p>具体操作如下：1>点击“租赁查询”选择“租赁订单查询”展示所有租赁订单的状态，查看单一产品或单一订单的租赁情况，通过查询选项：物料名称、租赁订单、订单类型、客户合同编号等条件体现相应的订单内容。</p>
                            <div class="pt-10"><img src="../../../assets/zl-img1.jpg" alt="租赁管理"></div>
                            <p>2>.点击红色框内的：全部、待发货、部份发货、已完成、已取消等选项，查看租赁订单的完成情况。</p>
                            <div class="pt-10"><img src="../../../assets/zl-img2.jpg" alt="租赁管理"></div>
                            <p class="pt-10">3>.租赁订单的管理，如售后维修、延长租赁时间或合同到期后的退还等，只需点击相应的业务选项对应的产品批次号，退可提交业务申请。</p>
                            <div class="pt-10"><img src="../../../assets/zl-img3.jpg" alt="租赁管理"></div>
                        </div>
                        <!-- 租赁价格查询 -->
                        <div v-if="resultForm.includes('2_3')">
                           <h4 class="pt-10">三、租赁询价查询</h4>
                            <p>1>.租赁价格查询：点击“租赁查询”选择“租赁价格查询”，输入需要租赁的产品：品牌、机型、模块、品项、物料名称等单选或多选条件快速查询租赁的价格；</p>
                            <div class="pt-10"><img src="../../../assets/zl-img4.jpg" alt="租赁管理"></div>
                            <p class="pt-10">2>.或直接点击“新建租赁订单”查询价格或提出租赁申请。（这里也可以新建采购申请单）</p>
                            <div class="pt-10"><img src="../../../assets/zl-img5.jpg" alt="租赁管理"></div>
                            <p class="pt-10">3>提交“租赁申请单”前，请选择对应的发货方式、订单类型、联系人及联系方式地址、产品品项、租赁期限、维修服务期限等主要选项，备注产品租赁申请的特殊需求，点击“提交并等待客户确认”即成功提交“租赁申请单。后台工作人员会即时处理并与您确认联系。</p>
                            <div class="pt-10"><img src="../../../assets/zl-img6.jpg" alt="租赁管理"></div>
                        </div>
                        <!-- 委托库查询 -->
                        <div v-if="resultForm.includes('3_1')">
                            <h4 class="pt-10">一、委托库查询</h4>
                            <p>委托产品库存是指合作库平台共享开放给全部用户的产品库存，产品状态分：可租可售、只售、只租等情况，用户可根据自身业务需求（租赁、采购）选择对应的产品，提交业务申请。</p>
                            <div class="help-pd"><img src="../../../assets/kc-img1.jpg" alt="库存查询"></div>
                        </div>
                        <!-- 代管库查询 -->
                        <div v-if="resultForm.includes('3_2')">
                            <h4 class="pt-10">一、代管库查询</h4>
                            <p>代管库是用户委托平台代为管理的产品，产品包含用户自己的产品和从合作库平台租赁的产品，用户登录后在线设置安全库存数据与适时自主调拨管理。</p>
                            <p>1> 点击“库存查询”选择代管库查询代管总库存、租赁代管库、自有代管库等产品的详细情况；</p>
                            <div class="help-pd"><img src="../../../assets/kc-img2.jpg" alt="库存查询"></div>
                            <p class="pt-10">2>为达到库存的合理化管理，减少资产积压，可以通过设置安全库存的“上下限设置”，设置后系统会根据调拨使用情况自动提示，便捷更智能化的管理库存。</p>
                            <div class="help-pd"><img src="../../../assets/kc-img3.jpg" alt="库存查询"></div>
                        </div>
                        <!-- 维修业务简介 -->
                        <div v-if="resultForm.includes('4_1')">
                           <h4 class="pt-10">一、维修业务简介</h4>
                            <p>(1)、合作库平台维修中心为用户提供多品牌多种机型的维修支持，包含基础维修和日立、OKI核心模块（机芯、验钞模块、EPP模块）的高端维修。</p>
                            <p>(2)、维修业务操作流程</p>
                            <div class="help-pd"><img src="../../../assets/menu_img8.png" alt="维修查询"></div>
                        </div>
                        <!-- 维修下单列表 -->
                        <div v-if="resultForm.includes('4_2')">
                            <h4 class="pt-10">二、维修订单列表</h4>
                            <p>1>点击“维修查询”选择“维修订单列表”即可管理查询所以维修订单的状态。查看方式可以输入“条件”查询，或选择订单的状态查询（待收货、待质检、待复核……等）</p>
                            <div class="help-pd"><img src="../../../assets/wx-img1.jpg" alt="维修查询"></div>
                            <p class="">2>单个产品的维修详细状态可点击“查看”</p>
                            <div class="help-pd"><img src="../../../assets/wx-img2.jpg" alt="维修查询"></div>
                        </div>
                        <!-- 维修价格查询 -->
                        <div v-if="resultForm.includes('4_3')">
                            <h4 class="pt-10">三、维修询价查询</h4>
                            <p>(1)、维修价格查询：</p>
                            <p>点击“维修查询”选择“维修价格查询”即可查询配件的标准维修价格，故障维修要按故障问题点报价，用户可选择快捷上或点击“新建维修单”在线录入信息后提交维修申请单。由后台客服回复处理。</p>
                            <div class="help-pd"><img src="../../../assets/wx-img3.jpg" alt="维修查询"></div>
                            <p>(2)、维修下单：</p>
                            <p>1>.点击新建修修单，录入需要维修的产品提交</p>
                            <div class="help-pd"><img src="../../../assets/wx-img4.jpg" alt="维修查询"></div>
                        </div>
                        <!-- 发货单列表 -->
                        <div v-if="resultForm.includes('5_1')">
                            <h4 class="pt-10">一、发货单管理</h4>
                            <p>发货单管理：用户在合作库平台发出的发货申请指定全部展示在这里，支持适时查询平台的处理进度。</p>
                            <p>(1)、点击“物流信息查询”选择“发货单列表”展示所有发货单的情况，可选择“待发货、和已发货”状态展示哪些发货单已发货或待发货，已发货的产品可从物流订单列表查询到产品的配送与抵达时间</p>
                            <div class="help-pd"><img src="../../../assets/wl-img1.jpg" alt="物流查询"></div>
                        </div>
                        <!-- 物流信息列表 -->
                        <div v-if="resultForm.includes('5_2')">
                            <h4 class="pt-10">二、物流订单列表</h4>
                            <p>已授理的发货申请单在“物流订单列表”展示，支持用户适时查询物流配送进度与送达时间。</p>
                            <p>(1)、点击“物流信息查询”选择“物流订单列表”展示所有已发货产品的物流配送状态，点击“查看”可展示单一产品物料配送的详细信息（图2）</p>
                            <div class="help-pd"><img src="../../../assets/wl-img2.jpg" alt="物流查询"></div>
                            <div class="help-pd"><img src="../../../assets/wl-img3.jpg" alt="物流查询"></div>
                        </div>
                        <!-- 委托收益报表 -->
                        <div v-if="resultForm.includes('6_1')">
                            <h4 class="pt-10">一、委托收益报表</h4>
                            <p>委托收益报表是指委托合作库成功租赁后的结算收入展示。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img1.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 委托销售报表 -->
                        <div v-if="resultForm.includes('6_2')">
                            <h4 class="pt-10">二、委托销售报表</h4>
                            <p>委托销售报表是指委托合作库成功销售后的结算收入展示。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img2.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 维修支出报表 -->
                        <div v-if="resultForm.includes('6_3')">
                            <h4 class="pt-10">三、维修支出报表</h4>
                            <p>维修支出报表是指委托合作库维修并向合作库支出的费用。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img3.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 物流支出报表 -->
                        <div v-if="resultForm.includes('6_4')">
                            <h4 class="pt-10">四、物流支出报表</h4>
                            <p>物流支出报表是指委托合作库发货产生的物流支出的费用。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img4.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 租赁支出报表 -->
                        <div v-if="resultForm.includes('6_5')">
                            <h4 class="pt-10">五、租赁支出报表</h4>
                            <p>租赁支出报表是指向合作库租赁配件所产生的支出费用，所有的租赁支出订单费用在这里展示查询。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img5.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 保证金报表 -->
                        <div v-if="resultForm.includes('6_6')">
                            <h4 class="pt-10">六、保证金支出报表</h4>
                            <p>保证金支出报表是指用户用于租赁业务的押金，合作库临时保管，业务结束后会退回用户帐户，展示所有订单支出的保证金，也能输入单个订单查询详情。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img6.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 代管支出报表 -->
                        <div v-if="resultForm.includes('6_7')">
                            <h4 class="pt-10">七、代管支出报表</h4>
                            <p>代管支出报表是指委托合作库代为管理所产生的代管费用。</p>
                            <div class="help-pd"><img src="../../../assets/cw-img7.jpg" alt="财务查询"></div>
                        </div>
                        <!-- 发货通知单 -->
                        <div v-if="resultForm.includes('7_1')">
                            <h4 class="pt-10">一、发货通知单</h4>
                            <p>(1)、发货通知单查询</p>
                            <p>1>点击“订单管理”选择“发货通知单”即可展示所有发货通知单的状态，单一发货单或具体产品查询看需输入条件选项查询操作。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img1.jpg" alt="订单管理"></div>
                            <p class="pt-10">(2)、新建发货申请单只针对有租赁代管和自有代管业务的产品</p>
                            <p>1>.点击“订单管理”选择“新建发货通知单”。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img2.jpg" alt="订单管理"></div>
                            <p class="pt-10">2>.选择要发货的产品，点击“加入发货”即可</p>
                            <div class="help-pd"><img src="../../../assets/dd-img3.jpg" alt="订单管理"></div>
                            <p class="pt-10">3>补充详细收货人电话地址，发货方式，如果需要发往不同地址，点击新增地址和新增产品，核对无误后点击提高，后台工作人员会接收发货申请并安排发货，必要时在发货前会与提前方进一步核实发货申请、收货人电话和地址等信息。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img4.jpg" alt="订单管理"></div>
                        </div>
                        <!-- 采购询价单 -->
                        <div v-if="resultForm.includes('7_2')">
                            <h4 class="pt-10">二、采购询价单</h4>
                            <p>所有采购询价单查询展示和新增采购询价单在这个界面操作，详情如下：</p>
                            <p>(1)、采购询价单查询：</p>
                            <p>1>.点击“订单管理”选择采购询价单，即可展示所有采购询价单的后台回复处理状态，或点击“查看”展示处理详情。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img5.jpg" alt="订单管理"></div>
                            <p class="pt-10">(2)、新建采购询价单</p>
                            <p>1>.点击“订单管理”1>.有产品采购需求的，需提交采购询价单，点击“订单管理”选择“采购询价单”，或点击“库存查询”选择“委托库查询”均可进入采购询价页面。，即可展示所有采购询价单的后台回复处理状态，或点击“查看”展示处理详情。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img6.jpg" alt="订单管理"></div>
                            <p class="pt-10">2>.选择“委托总库”只售产品清单，选择要采购的产品，点击“加入询价”即加入到采购询价单列表。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img7.jpg" alt="订单管理"></div>
                            <p class="pt-10">3>.选好要采购的产品后，点击“采购询价单”核对采购的产品是否正确，无误后补充联系方式后点击提高，等待或致电后台工作人员回复您的采购信息。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img8.jpg" alt="订单管理"></div>
                        </div>
                        <!-- 委托申请单 -->
                        <div v-if="resultForm.includes('7_3')">
                            <h4 class="pt-10">三、委托申请单</h4>
                            <p>新增配件委托业务的在以下页面查询和新增申请，详细操作如下：</p>
                            <p>(1)、委托申请单查询</p>
                            <p>1>点击“订单管理”选择“委托申请单”即能查询所有委托申请单列表，也可点击“查看”了解单个产品的详细处理情况。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img9.jpg" alt="订单管理"></div>
                            <p class="pt-10">(2)、新建委托申请单</p>
                            <p>1>.从订单管理下的委托申请或和从库存查询下的代管库查询均能执行“新建委托申请单”。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img10.jpg" alt="订单管理"></div>
                            <p class="pt-10">2>.委托申请暂只针对用户自有代管库的产品可线上操作，其它产品委托请直接联系客服，后续功能会增加直接上传功能。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img11.jpg" alt="订单管理"></div>
                            <p class="pt-10">3>.核对委托申请单的产品信息，选择委托时长（30.60.90.120.180.210天）、单价（委托的目标价）、委托类型（可租可售、只租、只售、代管），补充好相应信息后点击提交，后来工作人员会处理回复，提交的信息可在委托申请清单查询。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img12.jpg" alt="订单管理"></div>
                        </div>
                        <!-- 调度申请单 -->
                        <div v-if="resultForm.includes('7_4')">
                            <h4 class="pt-10">四、调度申请单</h4>
                            <p>合作库平台调度业务暂只针对代管产品，可申请发往任何地点，详细操作说明如下：</p>
                            <p>(1)、调度申请单查询</p>
                            <p>1>已申请的调度单查询，点击“订单管理”选择“调度申请单”即可查看所有的调度申请单，点击查看可展示调度单详情；</p>
                            <div class="help-pd"><img src="../../../assets/dd-img13.jpg" alt="订单管理"></div>
                            <p class="pt-10">(2)、新建调度申请单</p>
                            <p>1>.点击“库存查询”选择“代管库查询”下的租赁和自有代管库的产品列表，选择需要调度的产品点击“加入调度”即可进入“调度申请单”。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img14.jpg" alt="订单管理"></div>
                            <p class="pt-10">2>核对调度申请单产品、数量，录入调度的地址信息，调度的备注要求。确认无误即可提高信息，待后台处理并回复。</p>
                            <div class="help-pd"><img src="../../../assets/dd-img15.jpg" alt="订单管理"></div>
                        </div>
                        <!-- 公司信息 -->
                        <div v-if="resultForm.includes('8_1')">
                            <h4 class="pt-10">一、公司信息</h4>
                            <p>(1)、公司的基础信息的录入与管理，包含总部与分部的信息，有增加的点击新增即可。</p>
                            <div class="help-pd"><img src="../../../assets/gr-img1.jpg" alt="个人中心"></div>
                            <p class="pt-10">(2)、主要联系人的录入与管理：可以全部展示也可以查询展示，点击新增联系人可添加新的信息，通过编辑、分配帐户及权限、删除等管理联系人信息。</p>
                            <div class="help-pd"><img src="../../../assets/gr-img2.jpg" alt="个人中心"></div>
                            <p class="pt-10">(3)、帐户与权限设置：一个分部可设定一名主要责任人处理相应的事务。</p>
                            <div class="help-pd"><img src="../../../assets/gr-img3.jpg" alt="个人中心"></div>
                        </div>
                        <!-- 服务网点维护 -->
                        <div v-if="resultForm.includes('8_2')">
                            <h4 class="pt-10">二、服务网点信息</h4>
                            <p>(1)、服务网点的信息管理：可以修改网点或增加服务网点的信息资料，通过条件可快速查询某一网点的详细信息。</p>
                            <div class="help-pd"><img src="../../../assets/gr-img4.jpg" alt="个人中心"></div>
                        </div>
                        <!-- 工程师信息维护 -->
                        <div v-if="resultForm.includes('8_3')">
                            <h4 class="pt-10">三、工程师信息</h4>
                        <p>(1)、工程师的信息管理：可以修改或增加工程师的信息资料，通过条件可快速查询某一网点的工程师信息。</p>
                        <div class="help-pd"><img src="../../../assets/gr-img5.jpg" alt="个人中心"></div>
                        </div>
                        <!-- 在线反馈 -->
                        <div v-if="resultForm.includes('8_4')">
                            <el-row style='margin-top:20px'>
                                <h3 class='inputFormH3'>感谢你为平台提供的宝贵建议，每一次反馈将让我们的服务做得更好！</h3>
                                <el-form ref='inputForm' :model='inputForm' label-width="80px" :rules="rules">
                                <el-form-item label='备注' prop="text">
                                    <el-input type="textarea" placeholder="请输入反馈内容" v-model="inputForm.text"></el-input>
                                </el-form-item>
                                <el-col :span='2'>
                                    <el-form-item >
                                        <el-button type="primary" @click="onSubmit">立即创建</el-button>
                                    </el-form-item>
                                </el-col>
                                </el-form>
                            </el-row>
                        </div>
                        <!-- 搜索内容结束 -->
                    </div>
                    <div class="clear-fix help-wp5-bg help-right1">
                        <h3 class="help-right1-title1">联系我们</h3>
                        <el-row>
                            <el-col :span="12">
                                <div class="clear-fix help-kf help-kf-left">
                                    <span><img src="../../../assets/help_icon9.jpg" alt="phone"></span>
                                    <span class="help-qq"><a href="http://wpa.qq.com/msgrd?v=3&uin=2850559846&site=qq&menu=yes" target="_blank"><el-button plain><i class="fa fa-qq"></i>在线客户</el-button></a></span>
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="clear-fix help-kf">
                                    <span><img src="../../../assets/help_icon10.jpg" alt="phone"></span>
                                    <span class="help-qq help-phone">0755-82405890</span>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </el-col>
            </div>
        </el-col>
    </el-row>
</template>

<script>
export default {
  // 初始化时执行
  created() {
    this.initSearchWords()
  },
  data() {
    return {
      // 帮助文本集合 用于判断搜索关键字
      helpLists: [
        // 委托查询
        {key: '委托查询,配件采购,委托业务简介', id: '1_1'},
        {key: '委托查询,配件采购,委托订单列表', id: '1_2'},
        {key: '委托查询,配件采购,租赁收入列表', id: '1_3'},
        {key: '委托查询,委托收入,配件采购,出售收入列表', id: '1_4'},
        // 租赁查询
        {key: '租赁查询，租赁业务介绍,租赁结算,租赁业务简介', id: '2_1'},
        {key: '租赁查询，租赁结算,租赁订单查询', id: '2_2'},
        {key: '租赁查询，配件租赁，租赁结算,租赁价格查询', id: '2_3'},
        // 库存查询
        {key: '库存查询,委托库存，委托库查询', id: '3_1'},
        {key: '库存查询,代管库查询', id: '3_2'},
        // 维修查询
        {key: '维修查询,维修业务,维修结算,维修业务简介', id: '4_1'},
        {key: '维修查询,维修申请，申请维修,维修结算,维修下单列表', id: '4_2'},
        {key: '维修查询,维修价格，技术维修,维修结算,维修价格查询', id: '4_3'},
        // 物流信息查询
        {key: '物流信息查询,物流订单管理,发货申请,物流下单,物流查询,发货单管理,发货单列表', id: '5_1'},
        {key: '物流信息查询,物流订单管理,发货申请,物流下单,发货查询,发货单管理,物流信息列表', id: '5_2'},
        // 财务查询
        {key: '财务查询,委托收益报表', id: '6_1'},
        {key: '财务查询,委托销售报表', id: '6_2'},
        {key: '财务查询,维修费用，维修支出报表', id: '6_3'},
        {key: '财务查询,物流支出报表', id: '6_4'},
        {key: '财务查询,租赁费用，租赁支出报表', id: '6_5'},
        {key: '财务查询,保证金报表', id: '6_6'},
        {key: '财务查询,代管库支出报表', id: '6_7'},
        // 订单管理
        {key: '订单管理,物流发货,发货通知单', id: '7_1'},
        {key: '订单管理,采购询价单', id: '7_2'},
        {key: '订单管理,加入委托,委托申请单', id: '7_3'},
        {key: '订单管理,调度申请单', id: '7_4'},
        // 个人中心
        {key: '个人中心, 帐户管理,账户管理，公司信息', id: '8_1'},
        {key: '个人中心，网点信息,服务网点维护', id: '8_2'},
        {key: '个人中心，工程师信息维护', id: '8_3'},
        {key: '个人中心，在线反馈', id: '8_4'},
        // {key: '租赁业务简介', id: 'ZLYWJJ'},
        // {key: '租赁询价与下单', id: 'ZLXJYXD'},
        // {key: '租赁业务管理', id: 'ZLYWGL'},
        // {
        //   title: '委托管理',
        //   childrens: [
        //     {key: '委托业务简介', id: 'WTYYJJ'},
        //     {key: '委托下单', id: 'WTXD'},
        //     {key: '委托账户管理', id: 'WTTZZHL'},
        //   ]},
        // {
        //   title: '租赁管理',
        //   childrens: [
        //     {key: '租赁业务简介', id: 'ZLYWJJ'},
        //     {key: '租赁询价与下单', id: 'ZLXJYXD'},
        //     {key: '租赁业务管理', id: 'ZLYWGL'},
        //   ]},
      ],
      resultForm: [],  // 搜索结果数组 保存符合的helpLists的id
      SearchWords: '', // 搜索关键字
      searchForm: '',  // 搜索文本框
      isOnTop: true,   // 用来表示是否在当前页顶部，用于左侧浮动
      inputForm: {     // 在线反馈提交表单
        text: '',
      },
      rules: {     // 在线反馈表单验证
        text: [
          { required: true, message: '请输入反馈内容', trigger: 'blur' },
        ],
      },
      countDown: 0, // 提交限时每次间隔60,防止多次提交
    }
  },
  // 挂载后执行
  mounted() {
    // 监听屏幕滚动时间
    window.addEventListener('scroll', this.onScroll)
  },
  // 监听对象
  watch: {
  },
  // 计算属性
  computed: {
  },
  methods: {
    // 屏幕滚动时候左侧列表浮动
    onScroll: function(e, position) {
      // 获取当前屏幕高度
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      // 当高于一定高度时修改是否是顶部标识,这将影响左侧导航和右侧DOM的样式
      if (scrollTop > 200) {
        this.isOnTop = false
      } else {
        this.isOnTop = true
      }
    },
    // 初始化搜索关键字
    initSearchWords: function() {
      if (this.$route.params.SearchWords) {
        this.searchForm = this.$route.params.SearchWords
      }
      this.search()
    },
    // 提交在线反馈
    onSubmit: function() {
      this.$refs.inputForm.validate((valid) => {
        if (valid) {
          // 如果之前提交在一分钟之内则撤销请求
          if (this.countDown > 0) {
            this.$alert('请勿在短时间内重复提交!请稍后再试', '提交失败')
            return false
          }
          // 初始化倒计时时间
          this.countDown = 60
          // 创建倒计时任务,每秒时间减一直到零为止并清除任务
          let timer = setInterval(() => {
            if (this.countDown > 0) {
              this.countDown--
            } else {
              window.clearInterval(timer)
            }
          }, 1000)
          this.$alert('感谢你为平台提供的宝贵建议，每一次反馈将让我们的服务做得更好！', '提交成功')
        } else {
          return false
        }
      })
    },
    // 销毁时执行
    destroyed () {
      // 离开页面时移除事件监听 否则会报错
      window.removeEventListener('scroll', this.onScroll)
    },
    // 单独显示某一个帮助文本
    showHelp: function(id) {
      // 先清空结果集和搜索关键字对象
      this.resultForm = []
      this.SearchWords = ''
      // 将选中的ID传入到结果集中
      if (id) {
        this.resultForm.push(id)
      }
    },
    // 搜索帮助文本
    search: function() {
      // 清空结果集合
      this.resultForm = []
      // 获取输入的搜索文本绑定给搜索关键字对象
      this.SearchWords = this.searchForm.trim()
      // 遍历帮助解答集合
      this.helpLists.forEach(function(item) {
        // 判断是否包含有关键字
        if (item.key.includes(this.SearchWords)) {
          // 如果有则添加进结果集合
          this.resultForm.push(item.id)
        }
      }, this)
    },
  },
  components: {
  },
}
</script>
<style lang="less">
.helpList {
    h2{font-size:21px}
    h4{color:#00aeef}
    .hide{display:none}
    .show{display:block}
    .help-left-wp .el-collapse{border: none;padding-bottom: 10px }
    .clear-fix:after{clear: both;content: " ";display: block;height: 0;visibility: hidden;font-size: 0;}
    .clear{clear: both;}
    .fl{float: left;}
    .fr{float: right;}
    .pt-10,.pt-15,.pt-20,.pt-25,.pt-30{clear: both;}
    .pt-5{padding-top: 5px;}
    .pt-10{padding-top: 10px;}
    .pt-15{padding-top: 15px;}
    .pt-20{padding-top: 20px;}
    .pt-25{padding-top: 25px;}
    .pt-30{padding-top: 30px;}
    .pd-10{padding: 10px;}
    .pd-15{padding: 15px;}
    .pd-20{padding: 20px;}
    .text-center{text-align: center;}
    .text-right{text-align: right;}
    .color-red{color: #ff4e4e;}
    .color-green{color: #5FB878;}
    .color-blur{color: #00aeef;}
    .color-666{color: #666;}
    .color-999{color: #999;}

    .isFixed{position: fixed;top:10px;width:250px}
    .FixedRightBox{margin-left:250px}
    .wh1200{width: 1200px;margin: 0 auto;position: relative;}
    .wh1200:after{clear: both;content: " ";display: block;height: 0;visibility: hidden;font-size: 0;}
    .help-bg1{background: #fafafa;padding-bottom: 30px;}
    .help-wp1{padding-left: 80px;}
    .help-wp1 span{float: left;font-size: 70px;color: #d0d5d9;padding-right: 20px;}
    .help-wp1 span a{color: #d0d5d9;}
    .help-wp1 h3{padding-top: 17px;font-size: 18px;}
    .help-wp1 p{padding-top: 14px;color: #666;}
    .help-bg2{background: #fff;}
    .help-title1{padding-top: 40px;position: relative;text-align: center;}
    .help-title1 span{background: #fff;font-size: 30px;position: relative;z-index: 1;padding: 0 10px;}
    .help-title1:after{content: " ";display: block;height: 1px;background: #e1e1e1;position: absolute;bottom: 10px;width: 100%;}
    .help-title2 span{background: #4dacc2;color: #fff;}
    .help-title2:after{background: #fff;bottom: 14px;}
    .help-ul1{padding-top: 40px;padding-bottom: 40px;}
    .help-ul1 li{float: left;margin: 10px;}
    .help-ul1 a{color: #999;background: #fbfbfb;border: solid 1px #ededed;padding: 8px 10px;}
    .help-ul1 a:hover{border: solid 1px #00aeef;}
    .help-wp2{padding: 30px 30% 80px;}
    .help-bg3{background: #4dacc2;}
    .help-wp3{padding: 30px 0 100px;}
    .help-ask-wp{color: #fff;padding: 60px 5% 0;}
    .help-ask-wp div{position: relative;padding-left: 40px;line-height: 1.8em;}
    .help-ask-wp span{background: #308296;width: 22px;height: 22px;line-height: 22px;border-radius: 3px;text-align: center;font-size: 12px;font-weight: normal;position: absolute;left: 0;top: 2px;z-index: 1;}
    .help-ask-a{margin-top: 10px;min-height: 50px;}
    .help-ask-a span{background: #F2664B;}
    .help-ul2{line-height: 1.8em;}
    .help-ul2 li:first-child{font-size: 18px;font-weight: bold;padding-top: 15px;padding-bottom: 5px;}
    .help-wp4{padding: 30px 0 80px;}
    .help-wp4-ul{padding-top: 30px;}
    .help-wp5{border-top: solid 5px gray;background: #fff;border-radius: 4px;}
    .help-wp6{padding: 30px 0 20px;}
    .help-left1{margin-right: 20px;}
    .help-left-wp{padding: 0 10px;}
    .help-left-title{padding: 20px 0;font-weight: normal;}
    .help-left-ul1 i{padding-right: 10px;}
    .help-left-wp .el-collapse-item__content{padding-bottom: 15px;}
    .help-left-ul1 li{line-height: 2em}
    .help-left-ul1 li a:focus{color:#00aeef}
    .help-wp2-search{padding: 20px 30% 0;}
    .help-right1{padding: 20px 10px;line-height: 1.8em;}
    .help-right1-title1{font-weight: normal;font-size: 18px;padding-bottom: 10px;border-bottom: solid 1px #ddd;}
    .help-right1-title2{font-weight: normal;font-size: 24px;padding-bottom: 10px;border-bottom: solid 1px #ddd;}
    .help-right1-title2 span{color: #00aeef;}
    .help-right1-title2 strong{font-weight: normal;color: red;}
    .help-right1 h4{color: #00aeef;}
    .help-wp5-bg{background: #fff;}
    .help-no-text{padding-top: 20px;color: #666;line-height: 2em;font-size: 16px;}
    .help-qq{padding-top: 30px;padding-left: 20px;}
    .help-qq i{padding-right: 10px;}
    .help-kf{margin: 30px 0;text-align: center;}
    .help-kf span{vertical-align: top;}
    .help-kf-left{border-right: solid 1px #ddd;}
    .help-phone{font-size: 30px;padding-top: 38px;}
    .help-fixed{width: 230px;padding: 10px;background: #fff;top: 0;}
    .table-01{margin: 10px 0;width: 100%;}
    .table-01 th{background: #F2F2F2;}
    .table-01 td,.table-01 th{border: solid 1px #ddd;padding: 5px;}
    .help-pd{padding: 10px 0;}
    .help-search-wp{background: #dcebf6;padding-bottom: 20px;}
    .help-right1 p{font-weight: bold;max-width: 94%;margin: 0 auto;}
    // .help-right1 div{text-align: center;}
    // 2017/10/27 添加的样式 by 菠萝
    .inputFormH3{font-size:16px;padding-bottom:10px}
    .el-textarea__inner{height:80px}
}
.helpList.main-content{padding:0;}
</style>



// WEBPACK FOOTER //
// HelpListPage.vue?51993d32